import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";

function Admin_Profile() {
  

  const countryOptions = [
    { value: "india", label: "India" },
    { value: "usa", label: "USA" },
    { value: "uk", label: "UK" },
    { value: "australia", label: "Australia" },
  ];



  return (
    <>
      <section className="Profile card_box">
        <div className="profile_img_holder">
          <div className="img_holder">
            <img
              src="/assets/images/portal/profile/student_img_1.webp"
              alt="student 1"
              className="profile_img"
            />
          </div>
        </div>

        {/* Edit Button */}
        <div className="  d-flex justify-content-md-end justify-content-center">
          <Blue_border_button button_text="Edit Profile" />
        </div>

        <div className="form_holder">
          <Form>
            <div className="row">
              {/* Full Name */}
              <div className="col-md-4 mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Full name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your full name"
                  />
                </Form.Group>
              </div>

              {/* Email */}
              <div className="col-md-4 mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email id"
                  />
                </Form.Group>
              </div>

              {/* Contact Number */}
              <div className="col-md-4 mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Contact Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your contact number"
                  />
                </Form.Group>
              </div>

              {/* Date of Birth */}
              <div className="col-md-4 mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Date of birth</Form.Label>
                  <Form.Control type="date" />
                </Form.Group>
              </div>

              

              {/* Country – react-select */}
              <div className="col-md-4 mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Country</Form.Label>
                  <Select
                    options={countryOptions}
                    placeholder="Select country"
                    classNamePrefix="react_select"
                  />
                </Form.Group>
              </div>

              {/* Address */}
              <div className="col-md-12 mb-4">
                <Form.Group className="form_field">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Your Current Address"
                  />
                </Form.Group>
              </div>

              
            </div>
          </Form>
        </div>
      </section>
    </>
  );
}

export default Admin_Profile;
